import { Menu, X } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import AreaManagement from "./AreaManagement";
import CityManagement from "./CityManagement";
import MerchantFeeManagement from "./MerchantFeeManagement";
import PackageSizeManagement from "./PackageSizeManagement";
import PickPackManagement from "./PickPackManagement";

const Configuration = () => {
  const [activeTab, setActiveTab] = useState("cities");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { t } = useTranslation();

  const tabOptions = [
    { id: "cities", label: t("configuration.tabs.cities") },
    { id: "areas", label: t("configuration.tabs.areas") },
    { id: "packages", label: t("configuration.tabs.packages") },
    { id: "pickpack", label: t("configuration.tabs.pickpack") },
    { id: "fee", label: t("configuration.tabs.fee") },
  ];

  return (
    <div className="p-4 md:p-6 flex flex-col md:flex-row gap-6">
      {/* Mobile Menu Toggle */}
      <div className="md:hidden flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">{t("configuration.title")}</h1>
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="text-gray-600 hover:text-gray-900"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Sidebar Navigation */}
      <div
        className={`
        ${isMobileMenuOpen ? "block" : "hidden"} 
        md:block 
        md:w-1/4 
        lg:w-1/5 
        bg-white 
        shadow-md 
        rounded-lg 
        p-4
      h-fit`}
      >
        <div className="flex flex-col space-y-2">
          {tabOptions.map((tab) => (
            <button
              key={tab.id}
              className={`
                w-full 
                text-left 
                px-4 
                py-2 
                rounded-md 
                transition-colors 
                duration-200 
                ${
                  activeTab === tab.id
                    ? "bg-blue-100 text-blue-700"
                    : "text-gray-600 hover:bg-gray-100"
                }
              `}
              onClick={() => {
                setActiveTab(tab.id);
                setIsMobileMenuOpen(false);
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content Area */}
      <div className="md:w-3/4 lg:w-4/5">
        {activeTab === "cities" && <CityManagement />}
        {activeTab === "areas" && <AreaManagement />}
        {activeTab === "packages" && <PackageSizeManagement />}
        {activeTab === "pickpack" && <PickPackManagement />}
        {activeTab === "fee" && <MerchantFeeManagement />}
      </div>
    </div>
  );
};

export default Configuration;
